import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {
    VALIDATION_ICON_VALID,
    VALIDATION_ICON_INVALID,
    VALIDATION_ICON_LOADING
} from './../../constants';
import ValidationIcons from '../../reusable/ValidationIcons/ValidationIcons';
import xhr from './../../utils/xhr';

class DuplicateCheckField extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        duplicateCheckRequest: PropTypes.func.isRequired,
        messageIds: PropTypes.shape({
            labelId: PropTypes.string,
            placeholderId: PropTypes.string,
            errorMessageId: PropTypes.string
        }).isRequired,
        isRequired: PropTypes.bool,
        itemId: PropTypes.string,
        maxLength: PropTypes.number,
        initialValue: PropTypes.string,
        debounceTime: PropTypes.number,
        inputProps: PropTypes.object
    };

    static defaultProps = {
        initialValue: "",
        itemId: null,
        maxLength: 100,
        debounceTime: 1000,
        isRequired: false,
        inputProps: {}
    };

    constructor(props) {
        super(props);

        this.onInputChange = this.onInputChange.bind(this);
        this.duplicateCheck = this.duplicateCheck.bind(this);

        this.state = {
            value: props.initialValue,
            isValid: this.isValidNameStr(props.initialValue), // no initial value means not in edit mode
            errorMessage: null,
            iconState: null
        }
    }

    /**
     * Valid setter, the only one that also calls parent handler
     * @param isValid
     * @returns {DuplicateCheckField}
     */
    setValid(isValid) {
        this.setState({ isValid })
        this.props.onChange(isValid ? this.state.value : null);
        return this;
    }

    /**
     * Icon State setter
     * @param iconState
     * @returns {DuplicateCheckField}
     */
    setIconState(iconState) {
        this.setState({ iconState });
        return this;
    }

    /**
     * Error Message setter
     * @param errorMessage
     * @returns {DuplicateCheckField}
     */
    setErrorMessage(errorMessage) {
        this.setState({ errorMessage });
        return this;
    }

    /**
     * Value setter
     * @param value
     * @returns {DuplicateCheckField}
     */
    setValue(value) {
        this.setState({ value });
        return this;
    }

    /**
     * General function to check for string format
     * @param name
     */
    isValidNameStr = (name) => (name.trim().length > 0) && (name.trim().length <= this.props.maxLength)

    /**
     * Input onChange handler
     * @param event
     */
    onInputChange(event) {
        const value = event.target.value; // TODO: pass the value trimmed
        this.setValue(value)
            .setValid(false)
            .setIconState(null)
            .setErrorMessage(null)
    }

    /**
     * Async Function that calls for
     * @returns {*}
     */
    duplicateCheck() {
        const inputValue = this.state.value;
        this.setValid(false).setIconState(VALIDATION_ICON_LOADING).setErrorMessage(null)
        //do not validate if the name is empty
        if (!this.state.value) {
            this.setIconState(VALIDATION_ICON_INVALID);
            return false;
        }

        this.props.duplicateCheckRequest(inputValue, this.props.itemId).then(duplicate => {
            if (duplicate) {
                this.setValid(false)
                    .setIconState(VALIDATION_ICON_INVALID)
                    .setErrorMessage(this.props.messageIds.errorMessageId);
            } else {
                this.setValid(true).setIconState(VALIDATION_ICON_VALID).setErrorMessage(null);
            }
        }).catch((error) => {
            xhr.handleAllErrors(error);
            console.log("********************** Category Name Validation Failed ********************");
        })
    }

    renderCount = () =>  this.props.maxLength - this.state.value.length >= 0 ?
        this.props.maxLength - this.state.value.length : 0;

    renderErrorMessage = () => this.state.errorMessage ?
        <div className="error-message"><FormattedMessage id={this.state.errorMessage}/></div> : null;

    renderIcon = () => this.state.iconState ? <ValidationIcons renderState={this.state.iconState}/> : null;

    // TODO: Change classname to generic
    render = () =>  (
        <div className="category-name">
            <div className='category-name__title-characters'>
                <div>
                    <FormattedMessage id={this.props.messageIds.labelId}/>
                    { this.props.isRequired && <span className='required-field-star'></span> }
                </div>
                <div className='category-name__title-characters--remaining'>
                    <span>{this.renderCount()} </span>
                    <FormattedMessage id="Alerts_Create_UIText_name.step1.charactersRemaining"/>
                </div>
            </div>

            <div className="input-container">
                <input type="text"
                       maxLength={this.props.maxLength}
                       className="category-name-input"
                       onChange={this.onInputChange}
                       onBlur={this.duplicateCheck}
                       value={this.state.value}
                       placeholder={this.props.intl.formatMessage({id: this.props.messageIds.placeholderId})}
                       {...this.props.inputProps} />
                <div className='validation-icons'>{ this.renderIcon() }</div>
            </div>
            { this.renderErrorMessage() }
        </div>
    );
}

export default injectIntl(DuplicateCheckField);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/DuplicateCheckFieldBlur.jsx